import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showSnackbar } from "../../../api/snackbarSlice";
import { useDispatch } from "react-redux";
import { authApiClient } from "../../../utils/axios";
import { AxiosError } from "axios";
import { fetchOrgRequest } from "../../../api/organizations/orgSlice";
import { useCallback, useState } from "react";

export const mutateCustomFields = async ({ fieldName }) => {
  const { data } = await authApiClient.patch(
    "/organization/settings/custom-fields",
    {
      custom_fields: [{ field_name: fieldName }],
    },
  );

  return data;
};

export const useMutateCustomFieldsHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [apiError, setApiError] = useState(null);

  const mutation = useMutation({
    mutationFn: mutateCustomFields,
    onSuccess: () => {
      dispatch(fetchOrgRequest());
      queryClient.invalidateQueries({ queryKey: ["org"] });
      dispatch(
        showSnackbar({
          message: "Custom field added successfully",
          severity: "success",
        }),
      );
      setApiError(null);
      onSuccess && onSuccess();
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        const message = error?.response?.data?.errors?.message;

        if (message) {
          setApiError(message);
          dispatch(showSnackbar({ message, severity: "error" }));

          return;
        }

        dispatch(
          showSnackbar({
            message: "Failed to add custom field",
            severity: "error",
          }),
        );

        return;
      }

      dispatch(
        showSnackbar({
          message: "Failed to add custom field",
          severity: "error",
        }),
      );
    },
  });

  const clearApiError = useCallback(() => {
    setApiError(null);
  }, []);

  const onSubmit = useCallback(
    (fieldName) => {
      setApiError(null);
      mutation.mutate({
        fieldName: fieldName.trim(),
      });
    },
    [mutation],
  );

  return {
    isPending: mutation.isPending,
    onSubmit,
    apiError,
    clearApiError,
  };
};
